<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">Profile</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/">Home</router-link>
                                    </li>
                                    <li class="breadcrumb-item active" aria-current="page">Profile</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <section class="popular-menu-area pb-80 pt-custom">
            <div class="container">
                <p class="text-center">
                    <tabs
                            :tabs="tabs"
                            :currentTab="currentTab"
                            :wrapper-class="'default-tabs'"
                            :tab-class="'default-tabs__item'"
                            :tab-active-class="'default-tabs__item_active'"
                            :line-class="'default-tabs__active-line'"
                            @onClick="handleClick"
                    />
                </p>
                <div class="row pl-4" v-if="currentTab=== 'tab1'">
                    <div class="col-lg-6">
                        <div class="popular-menu-item mt-30 d-flex align-items-center">
                            <div class="popular-menu-thumb mr-30">
                                <p class="text-center">
                                    <img src="/img/profile/name.png" alt="name" style="width: 60px">
                                </p>
                            </div>
                            <div class="popular-menu-content">
                                <a href="#">
                                    <h5 class="title">{{$auth.user().name}}</h5>
                                </a>
                                <p>Name</p>
                            </div>
                        </div>
                        <div class="popular-menu-item mt-30 d-flex align-items-center">
                            <div class="popular-menu-thumb mr-30">
                                <p class="text-center">
                                    <img src="/img/profile/phone.png" alt="name" style="width: 60px">
                                </p>
                            </div>
                            <div class="popular-menu-content">
                                <a href="#">
                                    <h5 class="title">{{$auth.user().phone}}</h5>
                                </a>
                                <p>Phone</p>
                            </div>
                        </div>
                        <div class="popular-menu-item mt-30 d-flex align-items-center">
                            <div class="popular-menu-thumb mr-30">
                                <p class="text-center">
                                    <img src="/img/profile/location_name.png" alt="name" style="width: 60px">
                                </p>
                            </div>
                            <div class="popular-menu-content">
                                <a href="#">
                                    <h5 class="title">{{$auth.user().location_name}}</h5>
                                </a>
                                <p>Location</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="popular-menu-item mt-30 d-flex align-items-center">
                            <div class="popular-menu-thumb mr-30">
                                <img src="/img/profile/email.png" alt="name" style="width: 60px">
                            </div>
                            <div class="popular-menu-content">
                                <a href="#">
                                    <h5 class="title">{{$auth.user().email}}</h5>
                                </a>
                                <p>Email</p>
                            </div>
                        </div>
                        <div class="popular-menu-item mt-30 d-flex align-items-center">
                            <div class="popular-menu-thumb mr-30">
                                <p class="text-center">
                                    <img src="/img/profile/county.png" alt="name" style="width: 60px">
                                </p>
                            </div>
                            <div class="popular-menu-content">
                                <a href="#">
                                    <h5 class="title">{{$auth.user().county}}</h5>
                                </a>
                                <p>County</p>
                            </div>
                        </div>
                        <div class="popular-menu-item mt-30 d-flex align-items-center">
                            <div class="popular-menu-thumb mr-30">
                                <p class="text-center">
                                    <img src="/img/profile/address.png" alt="name" style="width: 60px">
                                </p>
                            </div>
                            <div class="popular-menu-content">
                                <a href="#">
                                    <h5 class="title">{{$auth.user().address}}</h5>
                                </a>
                                <p>Address</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row pl-4" v-if="currentTab=== 'tab2'">
                    <tabs
                            :tabs="subtabs"
                            :currentTab="currentSubTab"
                            :wrapper-class="'default-tabs'"
                            :tab-class="'default-tabs__item'"
                            :tab-active-class="'default-tabs__item_active'"
                            :line-class="'default-tabs__active-line'"
                            @onClick="handleSubClick"
                    />
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-8 mt-5 bg-white p-5">
                                <form v-if="currentSubTab=== 'subtab1'" @submit.prevent="updateAccount">
                                    <div class="row">
                                        <div class="col-lg-6 col-sm-12 col-md-6 mt-3">
                                            <h5>Name</h5>
                                            <input v-model="form.name" type="text" class="form-control">
                                            <small style="color: red" v-if="error && errors.name">{{ errors.name[0]
                                                }}</small>
                                        </div>
                                        <div class="col-lg-6 col-sm-12 col-md-6 mt-3">
                                            <h5>Your Phone Number</h5>
                                            <input v-model="form.phone" name="phone" type="tel" class="form-control">
                                            <small style="color: red" v-if="error && errors.phone">{{ errors.phone[0]
                                                }}</small>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="input-box mt-35 text-center">
                                                <button class="update-btn" type="submit">Update</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <form v-if="currentSubTab=== 'subtab2'" @submit.prevent="updateLocation">
                                    <div class="row justify-content-center">
                                        <div class="col-sm-7">
                                            <h5>Select new location</h5>
                                            <VueGooglePlaces
                                                    :api-key="key"
                                                    types="establishment"
                                                    country="ke"
                                                    @placechanged="onPlaceChanged"
                                                    @noresult="onNoResult">
                                                <input v-model="form.loc" type="text" class="form-control">
                                            </VueGooglePlaces>
                                            <small style="color: red" v-if="error && errors.location_name">{{
                                                errors.location_name[0] }}</small>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="input-box mt-35 text-center">
                                                <button class="update-btn" type="submit">Update</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <form v-if="currentSubTab=== 'subtab3'" @submit.prevent="updatePassword">
                                    <div class="row">
                                        <div class="col-lg-6 col-sm-12 col-md-6 mt-3">
                                            <h5>Old Password</h5>
                                            <input v-model="form.old_password" name="current_password" type="password"
                                                   placeholder="Password" class="form-control">
                                            <small style="color: red" v-if="error && errors.old_password">{{
                                                errors.old_password[0] }}</small>
                                        </div>
                                        <div class="col-lg-6 col-sm-12 col-md-6 mt-3">
                                            <h5>New Password</h5>
                                            <input v-model="form.new_password" name="password" type="password"
                                                   placeholder="Password" class="form-control">
                                            <small style="color: red" v-if="error && errors.new_password">{{
                                                errors.new_password[0] }}</small>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6 col-sm-12 col-md-6 mt-3">
                                            <h5>Confirm New Password</h5>
                                            <input v-model="form.new_password_confirmation" name="password"
                                                   type="password"
                                                   placeholder="Password" class="form-control">
                                            <small style="color: red" v-if="error && errors.new_password_confirmation">{{
                                                errors.new_password_confirmation[0] }}</small>
                                        </div>
                                        <div class="col"></div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="input-box mt-35 text-center">
                                                <button class="update-btn" type="submit">Update</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="vld-parent">
            <loading :active.sync="isLoading"
                     :can-cancel="true"
                     :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>

<script>
    import Tabs from "vue-tabs-with-active-line";
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        name: "Profile",
        components: {
            Tabs,
            Loading
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                error: false,
                errors: {},
                key: "AIzaSyD_q2KJ5vODTs1xOXxn6j8gjX5ZMr-2YzY",
                place: [],
                form: {
                    name: this.$auth.user().name,
                    phone: this.$auth.user().phone,
                    county: '',
                    longitude: '',
                    latitude: '',
                    address: '',
                    location_name: '',
                    old_password: '',
                    new_password: '',
                    new_password_confirmation: ''
                },
                tabs: [
                    {title: 'My Profile', value: 'tab1'},
                    {title: 'Update Profile', value: 'tab2'}
                ],
                currentTab: 'tab1',
                subtabs: [
                    {title: 'Account', value: 'subtab1'},
                    {title: 'Location', value: 'subtab2'},
                    {title: 'Password', value: 'subtab3'}
                ],
                currentSubTab: 'subtab1',
            }
        },
        methods: {
            updatePassword() {
                this.isLoading = true;
                this.axios.put('/customer/profile/password', this.form).then(() => {
                    this.isLoading = false;
                    this.$auth.fetch();
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Success!!',
                        text: 'Password updated!',
                    });
                    this.form = {
                        name: this.$auth.user().name,
                        phone: this.$auth.user().phone,
                        county: '',
                        longitude: '',
                        latitude: '',
                        address: '',
                        location_name: '',
                        old_password: '',
                        new_password: '',
                        new_password_confirmation: ''
                    }
                }).catch((resp) => {
                    this.isLoading = false;
                    this.error = true;
                    this.errors = resp.response.data.errors;
                })
            },
            updateLocation() {
                this.isLoading = true;
                this.axios.put('/customer/profile/location', this.form).then(() => {
                    this.isLoading = false;
                    this.$auth.fetch();
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Success!!',
                        text: 'Location details updated!',
                    });
                    this.form = {
                        name: this.$auth.user().name,
                        phone: this.$auth.user().phone,
                        county: '',
                        longitude: '',
                        latitude: '',
                        address: '',
                        location_name: '',
                        old_password: '',
                        new_password: '',
                        new_password_confirmation: ''
                    }
                }).catch((resp) => {
                    this.isLoading = false;
                    this.error = true;
                    this.errors = resp.response.data.errors;
                })
            },
            onNoResult() {

            },
            onPlaceChanged(e) {
                this.place = e;
                this.form.county = this.place.administrative_area_level_1;
                this.form.longitude = this.place.longitude;
                this.form.latitude = this.place.latitude;
                this.form.address = this.place.formatted_address;
                this.form.location_name = this.place.name;
            },
            updateAccount() {
                this.isLoading = true;
                this.axios.put('/customer/profile/account', this.form).then(() => {
                    this.isLoading = false;
                    this.$auth.fetch();
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Success!!',
                        text: 'Account details updated!',
                    });
                    this.form = {
                        name: this.$auth.user().name,
                        phone: this.$auth.user().phone,
                        county: '',
                        longitude: '',
                        latitude: '',
                        address: '',
                        location_name: '',
                        old_password: '',
                        new_password: '',
                        new_password_confirmation: ''
                    }
                }).catch((resp) => {
                    this.isLoading = false;
                    this.error = true;
                    this.errors = resp.response.data.errors;
                })
            },
            handleClick(newTab) {
                this.currentTab = newTab;
            },
            handleSubClick(newTab) {
                this.currentSubTab = newTab;
            },
        }
    }
</script>

<style lang="scss">
    .default-tabs {
        position: relative;
        margin: 0 auto;

        &__item {
            display: inline-block;
            margin: 0 5px;
            padding: 10px;
            padding-bottom: 8px;
            font-size: 16px;
            letter-spacing: 0.8px;
            color: gray;
            text-decoration: none;
            border: none;
            background-color: transparent;
            border-bottom: 2px solid transparent;
            cursor: pointer;
            transition: all 0.25s;

            &_active {
                color: black;
            }

            &:hover {
                border-bottom: 2px solid gray;
                color: red;
            }

            &:focus {
                outline: none;
                border-bottom: 2px solid gray;
                color: green;
            }

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }
        }

        &__active-line {
            position: absolute;
            bottom: 0;
            left: 0;
            height: 2px;
            background-color: blue;
            transition: transform 0.4s ease, width 0.4s ease;
        }
    }

    .content {
        margin-top: 30px;
        font-size: 20px;
    }
</style>